import { createCreateActionType, createCreateFetchingKey } from "@multiweb/reactUtils";

/**
 * Jméno modulu enums. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "enums";

/**
 * Pomocná funkce pro vytvoření typu akce.
 * @param actionType Typ akce
 */
const createActionType = createCreateActionType(NAME);

/**
 * Pomocná funkce pro vytvoření klíče načítání pro lokalizace enumů
 */
const createFetchingKey = createCreateFetchingKey(NAME);

/**
 * Doba čekání v ms, po kterou se seskupují akce požadující načtení enumů.
 * Hodnota je určena náhodně a je možné ji upravit po otestování v reálném použití.
 */
export const BATCHING_DELAY = 100;

/**
 * Klíč pro indikaci načítání lokalizace pro enumy ve fetching modulu.
 */
export const FETCHING_KEY_ENUMS_LOCALIZATION = createFetchingKey("FETCHING_KEY_ENUMS_LOCALIZATION");

/**
 * Načítání dat enumu na základě jména enumu.
 */
export const LOAD_ENUMS_DATA = createActionType("LOAD_ENUMS_DATA");

/**
 * Vložení dat týkajících se enumu do reduxu.
 */
export const SET_ENUMS_DATA = createActionType("SET_ENUMS_DATA");

/**
 * Smazání dat týkajících se enumu z reduxu.
 */
export const CLEAR_ENUM_DATA = createActionType("CLEAR_ENUM_DATA");
